module.exports = __webpack_public_path__ + "img/BQ.43c0cc37.svg";